export function MailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 4h14a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3zM4 7.37v9.216l4.756-4.756L4 7.37zM5.414 18h13.172l-4.818-4.818a3.001 3.001 0 01-3.536 0L5.414 18zM20 16.586V7.37l-4.756 4.459L20 16.586zM18.538 6H5.462l5.854 5.488a1 1 0 001.368 0L18.538 6z"
      ></path>
    </svg>
  );
}
